import { render, staticRenderFns } from "./Editcoupon.vue?vue&type=template&id=1d54a104&scoped=true&"
import script from "./Editcoupon.vue?vue&type=script&lang=js&"
export * from "./Editcoupon.vue?vue&type=script&lang=js&"
import style0 from "./Editcoupon.vue?vue&type=style&index=0&id=1d54a104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d54a104",
  null
  
)

export default component.exports